import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { ReviewCommentsService } from './review-comments.service';
import { ReviewComments } from '../../models/Flow';
import { DatePipe } from '@angular/common';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../../environments/environment';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-review-comments',
  templateUrl: './review-comments.component.html',
  styleUrls: ['./review-comments.component.scss']
})
export class ReviewCommentsComponent implements OnInit {
  @Input() reviewCommentInfo: string;
  public reviewForm: FormGroup;
  public reviewCommentList = [];
  public reviewCommmentLength = 0;
  public appName: string = environment.applicationName;
  constructor(
    private dialog: MatDialog, private commonService: TCCPCommonService, public reviewCommentsService: ReviewCommentsService) {
    this.commonService.reviewCommmentLength.subscribe((data) => {
      if (data) {
        this.reviewCommmentLength = data;
      } else {
        this.reviewCommmentLength = 0;
      }
    },
      (error) => {
      });
  }

  /* Review Comments Popup implementation */
  public dateInfo = '';
  openReviewCommentsPopup() {
    const dialogRef = this.dialog.open(ReviewCommentsDialogComponent, {
      id: 'review-comments-dialog',
      width: '700px', data: this.reviewCommentInfo
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  ngOnInit() {
    this.getReviewCommnets();
  }

  getReviewCommnets() {
    this.reviewCommentsService.getSubFeatureFlow(this.reviewCommentInfo['issueId'],
      this.reviewCommentInfo['source']).subscribe(flowResponse => {
        if (flowResponse) {
          this.reviewCommmentLength = flowResponse.Item.reviewComments && flowResponse.Item.reviewComments.length > 0
            ? flowResponse.Item.reviewComments.length : 0;
        }
      });
  }

}

@Component({
  selector: 'app-review-comments-dialog',
  templateUrl: './review-comments-dialog.html',
  styleUrls: ['./review-comments.component.scss']
})
export class ReviewCommentsDialogComponent implements OnInit {
  public reviewForm: FormGroup;
  public reviewCommentList = [];
  public appName: string = environment.applicationName;
  constructor(
    public dialogRef: MatDialogRef<ReviewCommentsComponent>,
    private reviewCommentsService: ReviewCommentsService, @Inject(MAT_DIALOG_DATA) public commentData: any,
    public authService: MsalService, public datePipe: DatePipe, private snackBar: MatSnackBar,
    private commonService: TCCPCommonService) { }


  ngOnInit() {
    this.reviewForm = new FormGroup({
      name: new FormControl({ value: this.authService.instance.getActiveAccount().username, disabled: true }),
      comment: new FormControl('', Validators.required)
    });
    this.getReviewCommnets();
  }

  onSave(reviewForm) {
    this.reviewForm.reset({});
    if (reviewForm.comment && reviewForm.comment !== '') {
      const comment: ReviewComments = < ReviewComments > {};
      comment.reviewedBy = this.authService.instance.getActiveAccount().username;
      comment.reviewComment = reviewForm.comment;
      comment.reviewedDate = new Date();

      this.reviewCommentsService.getSubFeatureFlow(this.commentData.issueId, this.commentData.source).subscribe(flowResponse => {
        if (flowResponse) {
          if (flowResponse.Item.reviewComments === undefined || flowResponse.Item.reviewComments === null) {
            flowResponse.Item.reviewComments = [];
          }
          flowResponse.Item.reviewComments.push(comment);
          this.reviewCommentsService.addReviewComments(flowResponse.Item, this.commentData.source).subscribe(data => {
            if (data) {
              this.reviewForm.reset({});
              console.log('flowResponse', data);
              this.getReviewCommnets();
              this.reviewForm.controls['comment'].setValue('');
              this.snackBar.open('Review Comment Added Successfully.', '', {
                duration: 2000,
                panelClass: ['green-snackbar']
              });
            }
          });
        }
      });
    }
  }

  getReviewCommnets() {
    this.reviewCommentList = [];
    this.reviewCommentsService.getSubFeatureFlow(this.commentData.issueId, this.commentData.source).subscribe(flowResponse => {
      if (flowResponse) {
        this.reviewCommentList = [];
        flowResponse.Item.reviewComments.filter(commentData => {
          const name = commentData.reviewedBy.split(' ');
          const displayName = name[0].charAt(0) + name[1].charAt(0);
          const reviewComment = commentData;
          reviewComment.displayName = displayName;
          reviewComment.reviewDate = this.datePipe.transform(reviewComment.reviewedDate,
            TCCPConstantValues.admin.FIXED_VALUES.DATE_FORMAT_WITH_SECONDS);
          this.reviewCommentList.push(reviewComment);
          this.commonService.reviewCommmentLength.emit(this.reviewCommentList.length);
        });
      }
    });
  }


  public hasError = (controlName: string, errorName: string) => {
    return this.reviewForm.controls[controlName].hasError(errorName);
  }

  onCancel() {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }


}
